<template>
  <section class="onboarding">
    <div class="onboarding__navigation">
      <Button
        v-if="selected !== 0"
        class="onboarding__button onboarding__button--left button--icon-only"
        button-background="transparent"
        button-color="dark"
        icon-left="chevron-left"
        @click.native="goToPrevious()"
      />
      <div class="onboarding__button onboarding__button--right button--text-only button--tiny btnSkip" @click="skipTutorial()">
        Skip
      </div>
<!--      <Button-->
<!--        class="onboarding__button onboarding__button&#45;&#45;right button&#45;&#45;text-only button&#45;&#45;tiny"-->
<!--        button-background="transparent"-->
<!--        button-color="dark"-->
<!--        title="Skip"-->
<!--        @click.native="skipTutorial()"-->
<!--      />-->
    </div>
    <div class="onboarding__steps">
      <Swiper
        ref="onboardingSwiper"
        :options="swiperOptions"
        class="onboarding__swiper"
        @slideChange="updateSelectedIndex()"
      >
        <SwiperSlide
          v-for="(step, index) in steps"
          :key="`step-${index}`"
          class="swiper__slide onboarding__slide"
        >
          <OnboardingStep
            :total-steps="steps.length"
            v-bind="step"
            :index="index"
          />
        </SwiperSlide>
      </Swiper>
      <div class="onboarding__footer">
        <div class="onboarding__pagination" />
        <Button
          class="onboarding__next"
          icon-right="arrow-right"
          :title="steps[selected].button_text"
          @click.native="goToNext()"
        />
      </div>
    </div>
  </section>
</template>

<script>
import OnboardingStep from '@/components/onboarding-step/OnboardingStep'
import Button from '@/components/partials/Button.vue'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'OnboardingSteps',
  components: {
    Button,
    OnboardingStep,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  props: {
    steps: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selected: 0,
      swiperOptions: {
        pagination: {
          el: '.onboarding__pagination',
          type: 'bullets',
          clickable: true
        }
      }
    }
  },
  methods: {
    goToOnboardingStep (index) {
      this.selected = index
    },
    goToNext () {
      return (this.selected < this.$refs.onboardingSwiper.$swiper.slides.length - 1)
        ? this.$refs.onboardingSwiper.$swiper.slideNext()
        : this.skipTutorial()
    },
    goToPrevious () {
      this.$refs.onboardingSwiper.$swiper.slidePrev()
    },
    skipTutorial () {
      this.$router.replace({ name: 'home' })
    },
    updateSelectedIndex () {
      this.selected = this.$refs.onboardingSwiper.$swiper.activeIndex
    }
  }
}
</script>

<style lang="scss">
.onboarding {
  &__navigation {
    position: relative;
    display: flex;
    justify-content: space-between;
    .button {
      &__text {
        font-weight: 400;
      }
      & + .button {
        margin-top: 0;
      }

    }
  }
  &__button {
    position: absolute;
    top: 0;
    z-index: 2;
    &--left {
      left: 0;
    }
    &--right {
      right: 0;
    }
  }
  &__swiper {
    .swiper-wrapper {
      align-items: stretch;
    }
  }
  &__slide {
    height: auto;
    .heading {
      margin-top: 1.5rem;;
    }
  }
  &__pagination {
    display: flex;
    justify-content: $onboarding-bullets-align;
    width: 100%;
    .swiper-pagination-bullet {
      display: inline-block;
      margin: $onboarding-bullets-margin;
      background-color: $onboarding-bullets-inactive-color;
    }
    .swiper-pagination-bullet-active {
      background-color: $onboarding-bullets-active-color;
    }
  }
  &__footer {
    padding: 0 $padding;
  }

  .btnSkip {
    text-transform: uppercase;
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: -0.5px;
    right: 1.3125rem;
    margin-top: 10px;
    cursor: pointer;
  }

}
</style>


<docs>
  ```vue
  <OnboardingSteps
    :steps="[
      {
        image: {
          url: 'assets/thishostel/images/onboarding-step-1@2x.jpg'
        },
        title: 'Title',
        subtitle: 'Subtitle',
        description: 'Description',
        button_text: 'Button text'
      },
      {
        image: {
          url: 'assets/thishostel/images/onboarding-step-1@2x.jpg'
        },
        title: 'Title',
        subtitle: 'Subtitle',
        description: 'Description',
        button_text: 'Button text 2'
      }
    ]"
  />
  ```
  ```scss
  // Variable defaults:
  $onboarding-bullets-align: flex-start;
  $onboarding-bullets-margin: 2.5rem 0.25rem;
  $onboarding-bullets-active-color: color(dark);
  $onboarding-bullets-inactive-color: color(dark, 0.2);
  ```
</docs>
